import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { LocaleParams } from "../../types";
import { addLead, getLead } from "../../helpers";
import { StepProgress, Button, GoBack } from "@cocunat/ui-components";
import { QUIZZ } from "../../constants";
import HeaderQuizz from "../quizz/components/HeaderQuizz";
import { getURLParams, t } from "../../helpers";
import { useLocation } from "react-router-dom";
import { getLeadingCommentRanges } from "typescript";

function LeadsNew() {
  let navigate = useNavigate();
  const { lang, country } = useParams<LocaleParams>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [lead, setLead] = useState({
    email: "",
    country: country,
    language: lang,
    name: "",
    form_place: "microsite-club",
  });
  let location = useLocation();
  const redirectPath = `https://club.cocunat.com/${lang}-${country}/products`;

  const isValidForm = () => {
    if (lead.email === "") {
      setErrorMsg("⚠ El campo 'email' no puede estar vacío");
      setError(true);
      return false;
    }

    if (!lead.email.includes("@")) {
      setErrorMsg("⚠ Debes incluir un email válido");
      setError(true);
      return false;
    }
    setErrorMsg("");
    setError(false);
    return true;
  };
  const saveLead = async () => {
    let valid = isValidForm();
    if (valid) {
      setLoading(true);
      try {
        let leadExist = await getLead(lead.email);
        if (leadExist.data.count <= 0) {
          addLead(lead).then((response) => {
            if (response.status === 201) {
              setLoading(false);
              window.location.href = redirectPath;
            }
          });
        } else {
          setErrorMsg(t("leads_error"));
          setError(true);
          setLoading(false);
        }
      } catch (e) {
        console.log(e);
        setLoading(false);
        window.location.href = redirectPath;
      }
    }
  };

  const changeLead = (e) => {
    let leadCopy = { ...lead };
    leadCopy[e.target.name] = e.target.value;
    setLead(leadCopy);
  };

  const goBack = () => {
    const searchParams = getURLParams(location.search);
    let userSelection = searchParams.selection.slice(0, -2);

    navigate(`/${lang}-${country}/quizz-new/5/?selection=${userSelection}`, {
      replace: true,
    });
  };

  return (
    <div className="quizz-page">
      <div className="container-small">
        <HeaderQuizz />
        <div className="go-back">
          <GoBack onClick={goBack} />
        </div>
        <p style={{ textAlign: "center", color: "#6F6F6F" }}>
          {5} / {Object.keys(QUIZZ).length}
        </p>
        <StepProgress
          current={5}
          steps={Object.keys(QUIZZ).length}
          style={{ justifyContent: "center" }}
        />
        <div>
          <h1 style={{ marginBottom: 5, fontSize: 18 }}>{t("leads_title")}</h1>
          <p style={{ textAlign: "left", marginTop: 0, marginBottom: 25 }}>
            {t("leads_subtitle")}
          </p>
          {error && errorMsg !== "" && (
            <div
              className="row"
              style={{ marginBottom: 15, marginLeft: 0, marginRight: 0 }}
            >
              <div
                style={{
                  borderColor: "red",
                  background: "#f44336",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: 15,
                }}
              >
                <p>{errorMsg}</p>
              </div>
            </div>
          )}

          <div
            className="row"
            style={{ marginBottom: 15, marginLeft: 0, marginRight: 0 }}
          >
            <p style={{ margin: 0, marginBottom: 5 }}>
              <strong> {t("leads_name")}:</strong>
            </p>
            <input
              type="text"
              name="name"
              onChange={changeLead}
              placeholder={t("leads_name")}
              value={lead.name}
              required
            ></input>
          </div>
          <div
            className="row"
            style={{ marginBottom: 15, marginLeft: 0, marginRight: 0 }}
          >
            {" "}
            <p style={{ margin: 0, marginBottom: 5 }}>
              <strong>Email:</strong>
            </p>
            <input
              type="email"
              name="email"
              onChange={changeLead}
              placeholder="Email"
              value={lead.email}
              required
            ></input>
          </div>
          <div
            className="row"
            style={{ marginBottom: 15, marginLeft: 0, marginRight: 0 }}
          >
            {" "}
            {lead.email !== "" && lead.email.includes("@") ? (
              <Button onClick={saveLead} loading={loading}>
                {t("unlock_promo")}
              </Button>
            ) : (
              <Button
                onClick={saveLead}
                style={{
                  backgroundColor: "#E5E5E5",
                }}
              >
                {t("unlock_promo")}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeadsNew;
